import { AdminTutorProfileHeader } from "./AdminTutorProfileHeader";
import React from "react";
import { useParams } from "react-router-dom";
import { useGetTutorQuery } from "../../../../../store/services/admin/UserService";
import { StarRating } from "../../../../components/Sessions/Elements/StarRating";

export const AdminTutorProfile = () => {
    const {id} = useParams();
    const {data} = useGetTutorQuery({id});
    
    // Format date function
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    };

    return (
        <div className="container py-4">
            <div className="row mb-4">
                <div className="col-12">
                    <AdminTutorProfileHeader tutor={data?.data} />
                </div>
            </div>
            
            {/* Reviews Section */}
            <div className="row">
                <div className="col-12">
                    <div className="card shadow-sm">
                        <div className="card-header bg-white">
                            <h4 className="mb-0">Reviews ({data?.data?.reviewList?.length || 0})</h4>
                        </div>
                        <div className="card-body p-4">
                            {data?.data?.reviewList && data.data.reviewList.length > 0 ? (
                                <div className="list-group list-group-flush">
                                    {data.data.reviewList.map((review, index) => (
                                        <div key={index} className="list-group-item border-0 px-0 py-3">
                                            <div className="d-flex align-items-start">
                                                <div className="flex-shrink-0">
                                                    <img
                                                        src={review.reviewerImage?.startsWith('https') 
                                                            ? review.reviewerImage 
                                                            : `${process.env.REACT_APP_IMAGE_PATH}${review.reviewerImage}`}
                                                        alt={review.reviewerFullName}
                                                        className="rounded-circle"
                                                        style={{
                                                            width: "50px",
                                                            height: "50px",
                                                            objectFit: "cover"
                                                        }}
                                                    />
                                                </div>
                                                <div className="flex-grow-1 ms-3">
                                                    <div className="d-flex justify-content-between align-items-start">
                                                        <div>
                                                            <h6 className="mb-1">{review.reviewerFullName}</h6>
                                                            <div className="d-flex align-items-center mb-2">
                                                                <StarRating value={review.count} />
                                                                <span className="ms-2 text-muted small">
                                                                    {formatDate(review.createdDate)}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <p className="mb-0 text-dark">{review.comment}</p>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div className="text-center py-4">
                                    <p className="text-muted mb-0">No reviews yet</p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};